import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { AdvisorId, ClientId, FartherAccountId, } from "../../Types";
import ValidationError from "../../ZodError";
import { ResponseBase } from "../Types";
export const LiquidationRequest = z.object({
    clientId: ClientId,
    advisorId: AdvisorId,
    accountId: FartherAccountId,
    accountName: z.string(),
    custodianAccountId: z.string(),
    amount: z.string().refine((val) => isNaN(parseFloat(val)) === false),
    isFullLiquidation: z.boolean(),
});
const PostResponseBody = z.object({
    data: ResponseBase,
});
export const postRaiseCashUrl = (planAssignmentId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/investment/raise-cash/${planAssignmentId}/liquidation`
    : `https://middleware.uat.farther.com/investment/raise-cash/${planAssignmentId}/liquidation`;
export default async function postRaiseCash(config, planAssignmentId, body, idempotencyKey) {
    const { data } = await axios.post(postRaiseCashUrl(planAssignmentId), body, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            version: "20250422",
            ...("advisorId" in config && { Advisor: config.advisorId }),
            "Idempotency-key": idempotencyKey,
            "Content-Type": "application/json",
        },
    });
    const decoded = PostResponseBody.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[postRaiseCash] returned unexpected data.";
        errorLog("postRaiseCash", JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=postRaiseCash.js.map